export const filterChipSx = (isSelected: boolean) => ({
  height: "auto",
  p: "7px 16px",
  border: "2px solid",
  borderRadius: "16px",
  borderColor: isSelected ? "primary.main" : "mockup.neutral90",
  "&.Mui-focusVisible": {
    outline: "2px solid",
    outlineColor: "primary.main",
    outlineOffset: "2px",
  },
  "& .MuiChip-label": {
    p: 0,
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    letterSpacing: "-0.08px",
  },
  ...(!isSelected && {
    bgcolor: "mockup.neutral100",
    color: "mockup.neutral0",
  }),
})
